module.exports = __webpack_public_path__ + "img/chinaEurope05.8b06b1ec.png";